import PropTypes from "prop-types";
import React from "react";
import DataGrid, { DataGridItem } from "components/data-grid";
import { injectIntl } from "react-intl";
import { TextDisplay } from "components/display-data";

const CustomerData = ({ customer, intl }) => {
  return !customer ? null : (
    <DataGrid>
      <DataGridItem>
        <TextDisplay label={intl.formatMessage({ id: "common.description" })}>{customer.description}</TextDisplay>
      </DataGridItem>
    </DataGrid>
  );
};

CustomerData.propTypes = {
  /**
   * Data to represent
   **/
  customer: PropTypes.object,
};

export default injectIntl(CustomerData);
